import axios from 'axios'
import { property as endpoint } from '@src/data/endpoint.json'

export const state = {
  drawer: null,
  snackbar: {
    text: '',
  },
  currentProperty: null,
}

export const getters = {
  propertyId: (state) =>
    state.currentProperty ? state.currentProperty.id : null,
}

export const mutations = {
  SET_DRAWER(state, newValue) {
    state.drawer = newValue
  },
  SET_SNACKBAR(state, payload) {
    const initData = {
      text: '',
    }
    state.snackbar = Object.assign({}, initData, payload)
  },
  SET_CURRENT_PROPERTY(state, newValue) {
    state.currentProperty = newValue
  },
}

export const actions = {
  fetchProperty({ commit, state }, { slug }) {
    const { currentProperty } = state
    if (currentProperty && currentProperty.url === slug) {
      return Promise.resolve(currentProperty)
    }

    return axios({
      url: endpoint.get,
      data: {
        slug,
        selects: ['id', 'name', 'url'],
      },
    }).then((response) => {
      const property = response.data
      commit('SET_CURRENT_PROPERTY', property)
      return property
    })
  },
}
